import { render, staticRenderFns } from "./table6.vue?vue&type=template&id=684ddaba&scoped=true&"
import script from "./table6.vue?vue&type=script&lang=js&"
export * from "./table6.vue?vue&type=script&lang=js&"
import style0 from "./table6.vue?vue&type=style&index=0&lang=css&"
import style1 from "./table6.vue?vue&type=style&index=1&id=684ddaba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ddaba",
  null
  
)

export default component.exports